import React, { useState, createContext, useContext } from 'react';
/**
 * App Registry Context
 * Manages available apps and provides registration system
 */
import { AppDefinition, AppRegistryContextValue } from '../types/app';
const AppRegistryContext = createContext<AppRegistryContextValue | undefined>(undefined);
interface AppRegistryProviderProps {
  children: ReactNode;
}
export function AppRegistryProvider({
  children
}: AppRegistryProviderProps) {
  const [apps, setApps] = useState<AppDefinition[]>([]);
  const registerApp = (app: AppDefinition) => {
    setApps(prev => {
      // Prevent duplicates
      if (prev.some(a => a.id === app.id)) {
        return prev;
      }
      return [...prev, app];
    });
  };
  const getAppById = (id: string) => {
    return apps.find(app => app.id === id);
  };
  const getAppsByCategory = (category: string) => {
    return apps.filter(app => app.category === category);
  };
  const value: AppRegistryContextValue = {
    apps,
    registerApp,
    getAppById,
    getAppsByCategory
  };
  return <AppRegistryContext.Provider value={value} data-id="element-980">
      {children}
    </AppRegistryContext.Provider>;
}
export function useAppRegistry() {
  const context = useContext(AppRegistryContext);
  if (!context) {
    throw new Error('useAppRegistry must be used within AppRegistryProvider');
  }
  return context;
}